module.exports = __webpack_public_path__ + "img/busd.8705fd81.svg";